import React from "react";
import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  TextField,
  withWidth,
} from "@material-ui/core";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { EyeEmpty, EyeOff } from "iconoir-react";
import Navbar from "../../../Gerneralcomponents/Navbar/Navbar";
import Swalgeneral from "../../../Landing/General/Swalgeneral";
import { domain } from "../../../Urls/Services/Api_urls";
import Logonew from "../../../assets/LogoNew.webp";
export default function Login3() {
  window.sessionStorage.clear();
  window.localStorage.clear();

  let respuesta = null;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const fromEmpresarial =
    location.pathname.toLowerCase().startsWith("/empresarial") ||
    location.state?.from?.toLowerCase().startsWith("/empresarial");

  const url = domain + "/login/";

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = useCallback(() => {
    setShowPassword((show) => !show);
  }, []);

  const handleMouseDownPassword = useCallback((event) => {
    event.preventDefault();
  }, []);

  useEffect(() => {
    window.sessionStorage.clear();
    if (window.sessionStorage.getItem("credentials")) {
      try {
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: window.sessionStorage.getItem("credentials"),
        }).then(async function (response) {
          if (response.status === 200) {
            navigate("../Dashboardprincipal", { replace: true });
          } else {
            window.sessionStorage.removeItem("credentials");          
            Swalgeneral("Error", "error", respuesta.msg);

          }
        });
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Hubo un error!",
          icon: "error",
          confirmButtonText: "Intentar",
        });
      }
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const credentials = { username, password };
    const user = JSON.stringify(username);
    const message = [];
    if (user === '""') {
      message.push("Ingresar nombre de usuario");
    }
    try {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials),
      }).then(async function (response) {
        if (response.status === 200) {
          let data_usuario = await response.json();
          window.sessionStorage.setItem(
            "credentials",
          credentials
          );

          window.sessionStorage.setItem("id", data_usuario.user["id"]);
          window.sessionStorage.setItem("token", data_usuario.token);
          window.sessionStorage.setItem("email", data_usuario.user["email"]);
          window.sessionStorage.setItem("ownername", data_usuario.user["owner_name"]);
          window.sessionStorage.setItem("cedula", data_usuario.user["dni"]);
          window.sessionStorage.setItem("phone", data_usuario.user["phone"]);
          window.sessionStorage.setItem("namedas", data_usuario.user["name"]);
          window.sessionStorage.setItem(
            "last_name",
            data_usuario.user["last_name"]
          );
          window.sessionStorage.setItem("groups", data_usuario.user["groups"]);
          window.sessionStorage.setItem("components", data_usuario.permissions_components);

          const nit = data_usuario.user["corporate_clients"]?.[0]?.nit || "";
          window.sessionStorage.setItem("nit", nit);

          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Has iniciado sesión correctamente.",
          });
          navigate("../Dashboardprincipal", { replace: true });
        } else {
          respuesta = await response.json();
          window.sessionStorage.clear();


          window.sessionStorage.removeItem("credentials");
          Swalgeneral("Error", "error", respuesta.msg);
        }
      });
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Hubo un error!",
        icon: "error",
        confirmButtonText: "Intentar",
      });
      console.error(error);
    }
  };

  return (
    <>
    <Navbar />
    <div className="overflow-y-auto"
    style={{
      height: 'calc(100vh - 4rem)', // Resta el alto del navbar
      marginTop: '4rem' // Opcional, si quieres separar visualmente
    }} >
      <div className="min-h-screen w-full flex items-center justify-center p-4"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg fill-opacity='0.27'%3E%3Cpath fill='%23f2efeb' d='M486 705.8c-109.3-21.8-223.4-32.2-335.3-19.4C99.5 692.1 49 703 0 719.8V800h843.8c-115.9-33.2-230.8-68.1-347.6-92.2C492.8 707.1 489.4 706.5 486 705.8z'/%3E%3Cpath fill='%23f1eade' d='M1600 0H0v719.8c49-16.8 99.5-27.8 150.7-33.5c111.9-12.7 226-2.4 335.3 19.4c3.4 0.7 6.8 1.4 10.2 2c116.8 24 231.7 59 347.6 92.2H1600V0z'/%3E%3Cpath fill='%23f3e6ce' d='M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z'/%3E%3Cpath fill='%23f8e3bc' d='M0 0v429.4c55.6-18.4 113.5-27.3 171.4-27.7c102.8-0.8 203.2 22.7 299.3 54.5c3 1 5.9 2 8.9 3c183.6 62 365.7 146.1 562.4 192.1c186.7 43.7 376.3 34.4 557.9-12.6V0H0z'/%3E%3Cpath fill='%23FFE1A7' d='M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z'/%3E%3Cpath fill='%23ffd9a9' d='M1600 0H0v136.3c62.3-20.9 127.7-27.5 192.2-19.2c93.6 12.1 180.5 47.7 263.3 89.6c2.6 1.3 5.1 2.6 7.7 3.9c158.4 81.1 319.7 170.9 500.3 223.2c210.5 61 430.8 49 636.6-16.6V0z'/%3E%3Cpath fill='%23ffd1ab' d='M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z'/%3E%3Cpath fill='%23ffcaae' d='M1600 0H498c118.1 85.8 243.5 164.5 386.8 216.2c191.8 69.2 400 74.7 595 21.1c40.8-11.2 81.1-25.2 120.3-41.7V0z'/%3E%3Cpath fill='%23ffc3b0' d='M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z'/%3E%3Cpath fill='%23FFBDB2' d='M1315.3 72.4c75.3-12.6 148.9-37.1 216.8-72.4h-723C966.8 71 1144.7 101 1315.3 72.4z'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover'
        }}>

          <div className="shadow-md backdrop-blur-sm rounded-3xl bg-white/80 flex flex-col justify-center items-center p-4 ...  ">
            <a href="/" className="flex items-start w-2/5 my-8 ">
            <img className="w-32" src={Logonew} alt="" />
            </a>
              <div style={{ height: 20 }} />
              <h2 className="text-2xl font-bold text-gray-800">
                {fromEmpresarial ? "Inicio empresarial" : "Iniciar sesión"}
              </h2>
              <div style={{ height: 10 }} />
              <p>
                Recuerda activar tu cuenta en el correo antes de <br /> iniciar
                sesion por primera vez
              </p>
              <div style={{ height: 20 }} />
              <form>
                <TextField
                  id="outlined-basic"
                  label="Correo"
                  variant="standard"
                  name="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={{ width: "18rem" }}
                />

                <div style={{ height: 20 }} />
                <FormControl sx={{ m: 1, width: "25ch" }}>
                  <InputLabel htmlFor="standard-adornment-password">
                    Contraseña
                  </InputLabel>

                  <Input
                    id="standard-adornment-password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={password}
                    style={{ width: "18rem" }}
                    onChange={(e) => setPassword(e.target.value)}
                    variant="standard"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <EyeOff /> : <EyeEmpty />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
                </FormControl>
            
                <button className="w-4/5 mt-5 text-white rounded-xl bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 ..." onClick={handleSubmit} type="submit">
                  Ingresar
                </button>
              </form>
              
              <a className="mt-10 text-red-950/70 rounded-xl  hover:text-red-600  focus:outline-none focus:ring focus:ring-red-300 no-underline	..." href="/Recuperar?type=Changepass">
                ¿Has olvidado la contraseña?
              </a>
           
              <a className="mt-6 text-red-950/70 rounded-xl  hover:text-red-600  focus:outline-none focus:ring focus:ring-red-300 no-underline	..." href={fromEmpresarial ? "/RegisterEmpresarial" : "/Register"}>
                Registrarme
              </a>
          </div>
      </div>
    </div>
    </>
  );
}
